<h3>Tools <span (click)="showTips=!showTips" title="hide/show tools">?</span></h3>
<div class="row tool-row">
    <div class="col-auto my-2">
        <button [ngClass]="colorOption == 'single' ? 'active' : ''" (click)="colorOption = 'single'" title="Color one cell"><span *ngIf="showTips">Color one cell</span> &#128853;</button>
    </div>
    <div class="col-auto my-2">
        <button [ngClass]="colorOption == 'row' ? 'active' : ''" (click)="colorOption = 'row'" title="Color row"><span *ngIf="showTips">Color row</span> &#8646;</button>
    </div>
    <div class="col-auto my-2">
        <button [ngClass]="colorOption == 'col' ? 'active' : ''" (click)="colorOption = 'col'" title="Color column"><span *ngIf="showTips">Color column</span> &#8645;</button>
    </div>
</div>
<div class="row tool-row">
    <div class="col-auto my-2">
        <button [ngClass]="colorOption == 'board' ? 'active' : ''" (click)="colorOption = 'board'" title="Color board"><span *ngIf="showTips">Color board</span> &#9638;</button>
    </div>
    <div class="col-auto my-2">
        <button (click)="shiftLeft()" title="Shift one column left"><span *ngIf="showTips">Shift one column left</span> &#8606;</button>
    </div>
    <div class="col-auto my-2">
        <button (click)="shiftRight()" title="Shift one column right"><span *ngIf="showTips">Shift one column right</span> &#8608;</button>
    </div>
</div>

<div class="row tool-row">
    <div class="col-auto my-2">
        <!-- <button (click)="clearBoard()" title="Clear board"><span *ngIf="showTips">Clear board</span> &#216;</button> -->
        <button (click)="addImage()" title="Add Image">
            <span *ngIf="showTips">Add Image</span>
            <label for="pic">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-camera" viewBox="0 0 16 16">
                <path d="M15 12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h1.172a3 3 0 0 0 2.12-.879l.83-.828A1 1 0 0 1 6.827 3h2.344a1 1 0 0 1 .707.293l.828.828A3 3 0 0 0 12.828 5H14a1 1 0 0 1 1 1v6zM2 4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-1.172a2 2 0 0 1-1.414-.586l-.828-.828A2 2 0 0 0 9.172 2H6.828a2 2 0 0 0-1.414.586l-.828.828A2 2 0 0 1 3.172 4H2z"/>
                <path d="M8 11a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5zm0 1a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7zM3 6.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0z"/>
              </svg>
            </label>
            <input type="file" name="pic" id="pic" accept="image/*" class="picInput d-none">
        </button>
    </div>
    <div class="col-auto my-2">
        <button (click)="shiftUp()" title="Shift one column up"><span *ngIf="showTips">Shift one column up</span> &#8593;</button>
    </div>
    <div class="col-auto my-2">
        <button (click)="shiftDown()" title="Shift one column down"><span *ngIf="showTips">Shift one column down</span> &#8595;</button>
    </div>
</div>
<div class="row">
    <img id="myImg" width=300>
</div>

<div class="row">
    <div class="col">

        <h6>Pick your color:</h6>
        <div data-toggle="modal" data-target="#colorPickModal" class="color-show" [style.background]="customColor"></div>

</div>
</div>

 <!-- <div class="row">
    <div class="col text-center">

        <div class="color-show" [style.background]="customColor"></div>
        <color-hue-picker 
            id="color-pick"
            (onChange)="colorChanged($event)" 
            (onChangeComplete)="colorChanged($event)" 
            [color]="customColor">
        </color-hue-picker>
        
        <color-chrome 
            id="color-pick"
            (onChange)="colorChanged($event)" 
            (onChangeComplete)="colorChanged($event)" 
            [color]="customColor">
        </color-chrome>

        <color-slider
            id="color-pick" 
            (onChange)="colorChanged($event)" 
            (onChangeComplete)="colorChanged($event)" 
            [color]="customColor">
        </color-slider>

        <input id="color-pick" (colorPickerChange)="customColor=$event; colorChanged()" [(colorPicker)]="customColor" [style.background]="customColor"/>
    </div>
</div> -->

<h5 class="mt-5" *ngIf="colorArray[0]" >Quick Colors:</h5>
<div class="row">
    <div class="col-auto">
        <div class="quick-color" 
            *ngFor="let color of colorArray" 
            [ngStyle]="{'background-color': color }"
            (click)="quickColorClick(color)">
        </div>
    </div>
</div>






<!-- Other Projects Modal -->
<!-- <div class="modal fade" id="savedDesignsModal" tabindex="-1" role="dialog" aria-labelledby="savedDesignsModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title" id="savedDesignsModalLabel">Edit Pattern</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <input placeholder="Name your Creation" [(ngModel)]="patternName" type="text">
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
            <button type="button" class="btn btn-primary" (click)="saveDesign()" data-dismiss="modal">Save changes</button>
        </div>
        </div>
    </div>
</div> -->